import { BlcLoader, Body, FlexBox, Headline } from '@Backlot-Cars/archie';
import { useTranslation } from 'next-i18next';

export const AuctionAccessLookupLoading = () => {
	const { t } = useTranslation(['signup']);

	return (
		<FlexBox
			alignItems="center"
			flexDirection="column"
			gap="lg"
			justifyContent="center"
			minHeight={280}
			padding="xl"
			role="status"
		>
			<BlcLoader size="larger" />
			<FlexBox alignItems="center" flexDirection="column" gap="xs">
				<Headline color="secondary" size="H3" textAlign="center">
					{t('signup:auctionAccessLookup.loading.title')}
				</Headline>
				<Body color="secondary" size="larger" textAlign="center">
					{t('signup:auctionAccessLookup.loading.subTitle')}
				</Body>
			</FlexBox>
		</FlexBox>
	);
};
